module.exports = __webpack_public_path__ + "img/chicos-web.a4085944.png";